import * as React from 'react';
import NavBar from './NavBar';
import Header from './Header';
import Footer from './Footer';
import { TimeoutLogic } from '../../pages/shared/components/sessionTimeOut/TimeoutLogic';

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        
        <div className="main-container">
            <Header />
            <NavBar />
            <div className="container-fluid">
                {props.children}
            </div>
            <TimeoutLogic/>
            <Footer />
        </div>
    </React.Fragment>
);